import React from 'react'
import { createNode, withRegion, clearNode } from 'effector'

export const createReactModel = <T, P>(fn: (p?: P) => T) => {
	const Ctx = React.createContext<T>(null)
	const Provider = Ctx.Provider
	const Consumer = Ctx.Consumer

	const useCtx = () => {
		const ctx = React.useContext(Ctx)
		return ctx
	}

	const Wrapper: React.FC<{ init?: P; children?: React.ReactNode }> = ({
		init,
		children,
	}) => {
		const [{ model, region }] = React.useState(() => {
			const region = createNode()
			let model: T = null
			withRegion(region, () => {
				model = fn(init)
			})
			return { region, model }
		})

		// eslint-disable-next-line react-hooks/exhaustive-deps
		React.useEffect(() => () => clearNode(region), [])

		return React.createElement(Provider, { value: model }, children)
	}
	return { Ctx, Provider, Consumer, useCtx, Wrapper }
}
